import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY, getToken, isPreviewSession, endPreviewSession, startPreviewSession } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const params = new URLSearchParams(window.location.search);
    const viewAs = params.get("view_as");
    if (viewAs) {
      startPreviewSession(viewAs);
      params.delete("view_as");
      const qs = params.toString();
      window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash);
    }
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      if (isPreviewSession()) endPreviewSession(); else localStorage.removeItem(TOKEN_KEY);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []); // `api`/TOKEN_KEY are module constants; stable callback by design

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback((token, payload) => {
    localStorage.setItem(TOKEN_KEY, token);
    setUser(payload);
  }, []);

  const logout = useCallback(() => {
    if (isPreviewSession()) { endPreviewSession(); setUser(null); return; }
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem("bgjc_last_active");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
